import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=16094ff7&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=16094ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16094ff7",
  null
  
)

export default component.exports